// src/components/navigation/MobileTopBar.tsx

import React from "react";
import { Link } from "react-router-dom";

import type { Notification } from "../../contexts/NotificationContext";
import type { UserDisplayInfo } from "../../types/navbar.types";

import { GradientText } from "./GradientText";
import { NotificationDropdown } from "./NotificationDropdown";
import { ProfileDropdown } from "./ProfileDropdown";

interface MobileTopBarProps {
  notifications: Notification[];
  unreadCount: number;
  userDisplayInfo: UserDisplayInfo;
  isLoggingOut: boolean;
  onNavigate: (path: string) => void;
  onLogout: () => void;
  onNotificationClick: (id: string) => void;
  onMarkAllAsRead: () => void;
  onViewAllNotifications: () => void;
}

export const MobileTopBar: React.FC<MobileTopBarProps> = ({
  notifications,
  unreadCount,
  userDisplayInfo,
  isLoggingOut,
  onNavigate,
  onLogout,
  onNotificationClick,
  onMarkAllAsRead,
  onViewAllNotifications,
}) => {
  return (
    <header
      className="
        fixed inset-x-0 top-0 z-50
        h-14 border-b border-[#E4EFED]
        bg-white px-4
        md:hidden
      "
    >
      <div className="flex h-full items-center justify-between">
        <Link
          to="/dashboard"
          className="
            flex min-w-0 items-center gap-2
            rounded-md
            focus-visible:outline-none
            focus-visible:ring-2
            focus-visible:ring-[#159A92]
            focus-visible:ring-offset-2
          "
          aria-label="Go to dashboard"
        >
          <img
            src="/IMG/Logo_Icon.PNG"
            alt=""
            className="h-8 w-8 shrink-0 object-contain"
            loading="eager"
            onError={(event) => {
              event.currentTarget.style.display = "none";
            }}
          />

          <GradientText className="truncate text-lg font-semibold leading-none">
            GluviaCare+
          </GradientText>
        </Link>

        <div className="flex shrink-0 items-center gap-1">
          <NotificationDropdown
            notifications={notifications}
            unreadCount={unreadCount}
            onNotificationClick={onNotificationClick}
            onMarkAllAsRead={onMarkAllAsRead}
            onViewAll={onViewAllNotifications}
            isActive={false}
            variant="mobile"
          />

          <ProfileDropdown
            userDisplayInfo={userDisplayInfo}
            isLoggingOut={isLoggingOut}
            onNavigate={onNavigate}
            onLogout={onLogout}
          />
        </div>
      </div>
    </header>
  );
};

export default MobileTopBar;